export default "__VITE_ASSET__DmvgH25S__"